import { IShop } from './interface/Shop';

export default Object.freeze({
  SHOP: IShop,
});
